import axios from "axios";
import { createMessage, createGenericErrorAlert } from "./messages";
import {setProjectDrop} from "./projects";
import { tokenConfig } from "./auth";

import { 
    GET_CONTRACT, 
    GET_CONTRACT_INVITATION_COUNT, 
    GET_CONTRACTS, 
    GET_CONTRACT_DROPS, 
    GET_CONTRACTS_OUTGOING, 
    GET_PROJECT_CONTRACTS, 
    GET_PROJECT_CONTRACTS_OUTGOING, 
    GET_CONTRACT_INVITATIONS, 
    RESPOND_TO_CONTRACT_INVITATION, 
    EDIT_CONTRACT, 
    CREATE_CONTRACT, 
    DELETE_CONTRACT, 
    CLEAR_CONTRACTS, 
    CLEAR_CONTRACT, 
    CLEAR_INVITATIONS, 
    EDIT_PROJECT,
    SET_CONTRACT_DROP,
    CLEAR_CONTRACTS_OUTGOING,
    GET_EX_ACCEPTED_CONTRACT,
    GET_NEW_ACCEPTED_CONTRACT,
    GET_CONTRACTS_INCLUDING_HIDDEN
 } from "./types";


// GET ALL CONTRACTS
export const getContracts = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/contract/get-contracts`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
                dispatch({
                    type: GET_CONTRACTS,
                    payload: [],
                });
            } else {
                const contracts = res.data;
                const contractDrops = res.data.map(contract => {
                    return {contract_id: contract.contract_id, contract_name: contract.contract_name, project_id: contract.project_id, project_name: contract.project_name}
                })
                dispatch({
                    type: GET_CONTRACTS,
                    payload: {contracts, contractDrops}
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
}

// GET ALL CONTRACTS
export const getContractsIncludingHidden = () => (dispatch, getState) => {
    // *** REPLACE WITH CALL THAT RETURNS CONTRACTS OF HIDDEN PROJECTS INCLUDED
    axios
        .get(`/v0/api/contract/get-contracts`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
                dispatch({
                    type: GET_CONTRACTS_INCLUDING_HIDDEN,
                    payload: [],
                });
            } else {
                const contracts = res.data;
                const contractDrops = res.data.map(contract => {
                    return {contract_id: contract.contract_id, contract_name: contract.contract_name, project_id: contract.project_id, project_name: contract.project_name}
                })
                dispatch({
                    type: GET_CONTRACTS_INCLUDING_HIDDEN,
                    payload: {contracts, contractDrops}
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
}



// SET CONTRACT DROP
export const setContractDrop = (contractDrop) => (dispatch, getState) => {
    dispatch({
        type: SET_CONTRACT_DROP,
        payload: contractDrop
    });
};

// GET ALL CONTRACTS RELATED TO OUTGOING INVOICES
export const getContractsOutgoing = () => (dispatch, getState) => {
    axios
        .get(`v0/api/contract/get-contract-outgoing-list`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_CONTRACTS_OUTGOING,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
}
// SET CONTRACT DROP
export const clearContractsOutgoing = () => (dispatch, getState) => {
    dispatch({
        type: CLEAR_CONTRACTS_OUTGOING,
        payload: []
    });
};

// GET CONTRACT INVITATIONS (BY USER PENDING)
export const getContractInvitations = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/contract/get-contract-pending-list`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_CONTRACT_INVITATIONS,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
// GET NUMBER OF CONTRACT INVITATIONS
export const getContractInvitationCount = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/contract/get-contract-pending-list-count`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                res.data.contract_invitations &&
                dispatch({
                    type: GET_CONTRACT_INVITATION_COUNT,
                    payload: res.data.contract_invitations,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// GET NEW CONTRACT INFO AFTER ACCEPTING INVITE 
export const getAcceptedContract = (contract_id, existing) => (dispatch, getState) => {
    axios
        .get(`/v0/api/contract/${contract_id}/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                const contract = res.data;
                const contractDrop = {
                    contract_id: res.data.contract_id,
                    contract_name: res.data.contract_name,
                    project_id: res.data.project_id,
                    project_name: res.data.project_name,
                } 
                dispatch(setProjectDrop({project_id: res.data.project_id, project_name: res.data.project_name,}))
                if (existing) {
                    dispatch({
                        type: GET_EX_ACCEPTED_CONTRACT,
                        payload: {contract, contractDrop},
                    });
                } else {
                    dispatch({
                        type: GET_NEW_ACCEPTED_CONTRACT,
                        payload: {contract, contractDrop},
                    });
                }
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// ACCEPT OR REJECT CONTRACT INVITATION
export const respondToContractInvitation = (inviteId, body, contract_id, existing) => (dispatch, getState) => {
    axios
        .put(`/v0/api/contract/role/${inviteId}/`, body, tokenConfig(getState))
        .then((res) => {
            // if answer is accept, check for res.error
            // if res.error = "need permissions" dispatch
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                if (body.status === "Active") {
                    dispatch(getAcceptedContract(contract_id, existing));
                    dispatch(createMessage({ success: "Role Accepted" }));
                } else if (body.status === "Rejected") {
                    dispatch(createMessage({ success: "Role Declined" }));
                }
                dispatch({
                    type: RESPOND_TO_CONTRACT_INVITATION,
                    payload: inviteId,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
// ACCEPT OR REJECT CONTRACT APPROVAL INVITATION
export const respondToApprovalInvitation = (inviteId, body, contract_id, existing) => (dispatch, getState) => {
    axios
        .put(`/v0/api/contract/approval/${inviteId}/`, body, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                if (body.status === "Active") {
                    dispatch(getAcceptedContract(contract_id, existing));
                    dispatch(createMessage({ success: "Role Accepted" }));
                } else if (body.status === "Rejected") {
                    dispatch(createMessage({ success: "Role Declined" }));
                }
                dispatch({
                    type: RESPOND_TO_CONTRACT_INVITATION,
                    payload: id,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};




// GET CONTRACT INFORMATION
export const getContract = (id) => (dispatch, getState) => {
    axios
        .get(`/v0/api/contract/${id}/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                const contract = res.data;
                const contractDrop = {
                    contract_id: res.data.contract_id,
                    contract_name: res.data.contract_name,
                    project_id: res.data.project_id,
                    project_name: res.data.project_name,
                }
                dispatch({
                    type: GET_CONTRACT,
                    payload: {contract, contractDrop},
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
// EDIT CONTRACT INFORMATION
export const editContract = (id, contract, message) => (dispatch, getState) => {
    axios
        .put(`/v0/api/contract/${id}/`, contract, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage(res.data));
            } else {
                const contract = res.data;
                const contractDrop = {
                    contract_id: res.data.contract_id, 
                    contract_name: res.data.contract_name, 
                    project_id: res.data.project_id, 
                    project_name: res.data.project_name
                }
                dispatch({
                    type: EDIT_CONTRACT,
                    payload: {contract, contractDrop},
                });
                // dispatch(createMessage({editContract: "Changes saved successfully."}));
                dispatch(createMessage({ success: message }));
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
// CREATE CONTRACT
export const createContract = (contract) => (dispatch, getState) => {
    axios
        .post("/v0/api/contract/", contract, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                const contract = res.data;
                const contractDrop = {
                    contract_id: res.data.contract_id, 
                    contract_name: res.data.contract_name, 
                    project_id: res.data.project_id, 
                    project_name: res.data.project_name
                }
                dispatch({
                    type: CREATE_CONTRACT,
                    payload: {contract, contractDrop},
                });
            }
            // dispatch(createMessage({success: message}));
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};


// DELETE CONTRACT
export const deleteContract = (id, name) => (dispatch, getState) => {
    axios
        .delete(`/v0/api/contract/${id}/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch(createMessage({ success: `Contract ${name} has been deleted` }));
                dispatch({
                    type: DELETE_CONTRACT,
                    payload: id
                });
            }
        })
        .catch((err) => console.log(err));
};

// CLEAR INVITATIONS
export const clearInvitations = () => (dispatch) => {
    dispatch({
        type: CLEAR_INVITATIONS,
        payload: null
    });
};

// CLEAR CONTRACTS
export const clearContracts = () => (dispatch) => {
    dispatch({
        type: CLEAR_CONTRACTS,
        payload: null
    });
};

// CLEAR CONTRACT
export const clearContract = () => (dispatch) => {
    dispatch({
        type: CLEAR_CONTRACT,
        payload: null
    });
};

// DISCARD CONTRACT DRAFT
export const discardContractDraft = (id) => (dispatch, getState) => {
    axios
        .delete(`/v0/api/contract/${id}/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: DELETE_CONTRACT,
                    payload: id
                });
            }
        })
        .catch((err) => console.log(err));
};
